import { HOME_PREVIEW_PATH, IS_US } from '@/utils/constants';

/**
 * 北美站底部订阅配置允许展示的页面
 */
export const US_FOOTER_SUBSCRIBE_PAGE = [
  '/',
  HOME_PREVIEW_PATH,
  '/goods-list',
  'search-result',
  '/goods-detail',
];

export const shouldShowUSFooterSubscribe = (pathname: string) =>
  IS_US &&
  US_FOOTER_SUBSCRIBE_PAGE.some((page) =>
    page === '/' ? pathname === page : pathname.includes(page),
  );
